import script from "./SidebarDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarDropdown.vue?vue&type=script&setup=true&lang=js"

import "./SidebarDropdown.vue?vue&type=style&index=0&id=dc2560d0&scoped=true&lang=css"
import "./SidebarDropdown.vue?vue&type=style&index=1&id=dc2560d0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc2560d0"]])

export default __exports__